<template>
  <v-card>
    <v-card-text>
      <h3>Panel numbers</h3>
      <v-btn @click="edit = true" v-if="!edit">
        <v-icon>add</v-icon>Panel number
      </v-btn>
      <div class="ajaxForm" v-if="edit">
        <h1>Create panel number</h1>
        <p>Select which branch the panel number relates to and click save</p>
        <v-form ref="panelNumberForm">
          <v-select
            v-model="branchesSelected"
            :items="branches"
            item-text="name"
            item-value="id"
            attach
            chips
            :rules="valueRules"
            label="Branch"
            multiple
            outline
          />
          <v-text-field
            label="Panel number"
            v-model="panelNo"
            :rules="valueRules"
            outline
          />
          <v-btn @click="save"> <v-icon>save</v-icon>Save </v-btn>
          <v-btn @click="edit = false">Cancel</v-btn>
        </v-form>
      </div>
      <v-alert
        :value="entity.mortgagePanels && entity.mortgagePanels.length == 0"
        type="warning"
        >No panel numbers recorded for this specific mortgage company, maybe
        group has panels?</v-alert
      >
      <template
        v-if="entity.mortgagePanels && entity.mortgagePanels.length > 0"
      >
        <div>
          {{ entity.mortgagePanels.length }}
          <span>&#160;panel numbers</span>
        </div>
        <v-data-table
          :headers="headers"
          :items="entity.mortgagePanels"
          hide-actions
          class="elevation-1"
        >
          <template v-slot:items="props">
            <tr>
              <td>
                <span v-if="!props.item.branch">No branch found</span>
                <EntityZ :entity="props.item.branch" v-if="props.item.branch" />
              </td>
              <td>{{ props.item.panelno }}</td>
              <td>
                <a @click="archive(props.item)">Archive</a>
              </td>
            </tr>
          </template>
        </v-data-table>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
import CREATE_ENTITY_MORTGAGE_PANEL from "@/graphql/directory/CreateEntityMortgagePanel";
import DELETE_ENTITY_MORTGAGE_PANEL from "@/graphql/directory/DeleteEntityMortgagePanel";
import TYPE_ENTITIES_UNARCHIVED_ORDER_BY_NAME from "@/graphql/directory/TypeEntitiesUnarchivedOrderByName";
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "PanelNumber",
  components: {
    EntityZ
  },
  props: ["entity", "lastUpdated"],
  apollo: {
    branches: {
      query: TYPE_ENTITIES_UNARCHIVED_ORDER_BY_NAME,
      variables() {
        return {
          id: 1
        };
      },
      // result: (data) => console.log(data),
      update: (data) => data.type.entitiesUnarchivedOrderByName,
      fetchPolicy: "cache-and-network"
    }
  },
  data() {
    return {
      edit: false,
      branchesSelected: null,
      panelNo: null,
      valueRules: [(v) => !!v || "Value is required"],
      headers: [
        {
          text: "Branch",
          value: "branchid"
        },
        {
          text: "Panel number",
          value: "panelno"
        },
        {
          text: "Archive",
          value: "id"
        }
      ]
    };
  },
  methods: {
    save() {
      if (this.$refs.panelNumberForm.validate()) {
        this.branchesSelected.forEach((val, key, arr) => {
          const last = Object.is(arr.length - 1, key);
          this.createMortgagePanel(val, last);
        });
        this.branchesSelected = null;
        this.panelNo = null;
        this.edit = false;
      }
    },
    async createMortgagePanel(branchid, last) {
      await this.$apollo.mutate({
        mutation: CREATE_ENTITY_MORTGAGE_PANEL,
        variables: {
          id: Number(this.$route.params.id),
          branchid,
          panelno: this.panelNo
        }
      });
      if (last) {
        this.$emit("triggerUpdate");
      }
    },
    async archive(mortgagePanel) {
      if (confirm("Are you sure?")) {
        await this.$apollo.mutate({
          mutation: DELETE_ENTITY_MORTGAGE_PANEL,
          variables: {
            id: Number(this.$route.params.id),
            mortgagePanelId: mortgagePanel.id
          }
        });
        this.$emit("triggerUpdate");
      }
    }
  }
};
</script>
